(function auditDefinition() {
    'use strict';
    angular.module('Entities')
        .service('auditService', [
            'restUrlBuilder', function auditService(restUrlBuilder) {

                var urlCpp = restUrlBuilder('cpp');

                this.get = function get(desc) {
                    var params;
                    if (desc) {
                        params = {
                            OrganizationalUnitId: desc.organizationalUnitId,
                            UserId: desc.userId,
                            ActionType: undefined,
                            DateFrom: desc.dateFrom,
                            DateTo: desc.dateTo,
                            Page: desc.page,
                            ItemPerPage: desc.itemPerPage,
                            UserName: desc.nickName,
                            entityName: desc.entityName,
                            entityId: desc.entityId
                        };

                        if (desc.actionType) {
                            params.ActionType = desc.actionType.id;
                        }
                    }

                    return urlCpp.all('audit/GetAudits')
                        .get({ params: params });
                };


                this.getById = function getById(id) {
                    return urlCpp.one('audit', id).get();
                };

                this.create = function (dto) {
                    if (dto == null)
                        throw "audit no puede ser null";
                    return urlCpp.all('audit')
                        .post(dto);
                };
           

                this.export = function (desc) {
                    var params;

                    if (desc) {
                        params = {
                            OrganizationalUnitId: desc.organizationalUnitId,
                            UserId: desc.userId,
                            ActionType: undefined,
                            DateFrom: desc.dateFrom,
                            DateTo: desc.dateTo,
                            Page: desc.page,
                            UserName: desc.nickName,
                            entityName: desc.entityName,
                            entityId: desc.entityId
                        };

                        if (desc.actionType) {
                            params.ActionType = desc.actionType.id;
                        }
                    }
                    return urlCpp.all('audit/ExportAudits').put(params);
                };
            }
        ]);
})();